module.exports = __webpack_public_path__ + "media/icons/offer-details-przod-da47e732.png";